import request from '@/utils/request'

/**
 * 获取积分赠送列表
 * @param {Object} params 请求参数
 * @returns {Promise} Promise对象
 */
export function listIntegralShopGift(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/integral.listIntegralShopGift',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}